import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FormCheckboxField from '@adv-mt/mt-form-checkbox-field'

import FormCardHasWarranty from './CardHasWarranty.js'

const FormHasWarranty = ({helpText, id, label, onChange, value}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    setTimeout(
      () =>
        onChange(e, {
          field: FILTER_NAMES.HAS_WARRANTY,
          value: checked,
          lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_WARRANTY]
        }),
      0
    )
  }

  return (
    <FormCheckboxField
      checked={value}
      helpText={helpText || i18n.t('FORM.WARRANTY_INCLUDED_HELP_TEXT')}
      id={id || FILTER_NAMES.HAS_WARRANTY}
      label={label || i18n.t('CARD_AD_GENERIC_WARRANTY_INCLUDED')}
      onChange={_handleOnChange}
    />
  )
}

FormHasWarranty.displayName = 'FormHasWarranty'
FormHasWarranty.propTypes = {
  helpText: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool
}

export {FormCardHasWarranty}

export default FormHasWarranty
